import { apiGet, apiPatch } from './client';
import type { RatingScale, RatingScaleBatchRequest } from '../types/RatingScale';

export function getRatingScale(): Promise<RatingScale[]> { return apiGet<RatingScale[]>('/api/rating-scale'); }

export function saveBatchRatingScale(added: RatingScale[], modified: RatingScale[], deletedIds: number[]): Promise<RatingScale[]> {
  return apiPatch<RatingScaleBatchRequest, RatingScale[]>('/api/rating-scale/batch', { added, modified, deleted: deletedIds });
}
